<template>
  <div class="card" @click="watchVideo(videoLecture.id)"
    :class="[ isList ? 'list' : '' ]"
    :style="videoPicture">
    <div class="card-gradient" :style="gradientStyle"></div>
    <div class="card-body">
      <div class="card-title">{{ videoSubjectName }}</div>
      <div class="card-subtitle mb-2">{{ videoTitle }}</div>
      <div class="card-action">
        <img src="/static/images/ic-video-play.svg" alt="play icon">
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import numbers from '@/mixins/numbers';

  import { find, maxBy } from 'lodash';

  export default {
    name: 'text-card',

    mixins: [
      numbers,
    ],

    props: {
      videoLecture: {
        type: Object,
      },
      isList: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        videoBackgroundSize: {
          width: 295,
          height: 166,
        },
      };
    },

    computed: {
      ...mapGetters({
        subjectMap: 'getSubjectMap',
      }),

      videoTitle() {
        return this.videoLecture.title;
      },

      filterSubject() {
        return find(this.subjectMap, { id: this.videoLecture.subject_id }) || {};
      },

      videoSubjectName() {
        return this.filterSubject.name;
      },

      videoSubjectColor() {
        return this.filterSubject.color_code;
      },

      video() {
        return this.videoLecture && this.videoLecture.video;
      },

      filterVideoPicture() {
        const videoPicture = find(this.video.pictures, { width: this.videoBackgroundSize.width });
        if (!videoPicture) {
          return maxBy(this.video.pictures, item => item.width);
        }

        return videoPicture;
      },

      videoPicture() {
        return {
          'background-image': `url('${this.filterVideoPicture.link}')`,
        };
      },

      gradientStyle() {
        return {
          'background-color': 'rgba(0, 0, 0, 0.4)',
        };
      },

    },

    methods: {
      watchVideo(videoId) {
        return this.$router.push(`/video/${videoId}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card {
    border: 0;
    display: inline-block;
    margin: 6px;
    width: 100%;
    cursor: pointer;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.05);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    &:hover {
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
    }

    .card-gradient {
      bottom: 0;
      left: 0;
      right: 0;
      position: absolute;
      height: 100%;
    }

    .card-body {
      height: 144px;
      position: relative;
      .card-title {
        color: #ffffff;
        font-size: 14px;
        font-weight: normal;
      }

      .card-subtitle {
        color: #ffffff;
        font-size: 16px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-inline-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        max-height: 20px;
        word-break: break-all;
        white-space: normal;
      }

      .card-action {
        position: absolute;
        bottom:4px;
        right: 4px;
      }
    }
  }

  .list {
    width: 222px;
    margin: 14px 6px 14px 6px;
  }
</style>


// WEBPACK FOOTER //
// TextCard.vue?02a55679